import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuditLogService } from '../../../../services/audit-log/audit-log.service';
import { AuditLogEntry, AuditLogFilter } from '../../../../services/audit-log/audit-log.model';
import { PaginatedList } from '../../../../services/organizations/organization.model';
import { AuditLogFilterComponent } from '../../../organisms/audit-log/audit-log-filter/audit-log-filter.component';
import { AuditLogTableComponent } from '../../../organisms/audit-log/audit-log-table/audit-log-table.component';
import { AuditLogDetailComponent } from '../../../organisms/audit-log/audit-log-detail/audit-log-detail.component';
import { RoleService } from '../../../../services/role/role.service';
import { UserRole } from '../../../../services/auth/auth.role';
import { ButtonComponent, LoadingDotsComponent, HeroSectionComponent } from 'htx-ui-library';

@Component({
  selector: 'app-audit-log-page',
  imports: [CommonModule, TranslocoPipe, AuditLogFilterComponent, AuditLogTableComponent, AuditLogDetailComponent, ButtonComponent, LoadingDotsComponent, HeroSectionComponent],
  templateUrl: './audit-log-page.component.html',
  styleUrl: './audit-log-page.component.scss'
})
export class AuditLogPageComponent implements OnInit {

  private auditLogService = inject(AuditLogService);
  private roleService = inject(RoleService);

  filter: AuditLogFilter = {};
  page = 0;
  pageSize = 20;
  result: PaginatedList<AuditLogEntry> | null = null;
  loading = false;
  selectedEntry: AuditLogEntry | null = null;
  isDsa = false;

  ngOnInit(): void {
    const roles = this.roleService.getUserRoles$().value;
    this.isDsa = roles.includes(UserRole.DataspaceAuthority);
    this.load();
  }

  onFilterChange(updatedFilter: AuditLogFilter): void {
    this.filter = updatedFilter;
    this.page = 0;
    this.load();
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    this.load();
  }

  onSelectEntry(entry: AuditLogEntry): void {
    this.selectedEntry = entry;
  }

  onCloseDetail(): void {
    this.selectedEntry = null;
  }

  exportCsv(): void {
    this.auditLogService.exportCsv(this.filter);
  }

  private load(): void {
    this.loading = true;
    this.auditLogService
      .findAll(this.filter, { page: this.page, size: this.pageSize, sort: 'occurredAt,desc' })
      .subscribe({
        next: (res) => {
          this.result = res;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }
}
